export const idExist = (id) => !!id && !isNaN(id);
